<div class="card w-100" *ngIf="arquivosAnexos; else semAnexo">
    <div class="table-responsive">
        <table class="table table-sm table-hover">
            <thead>
                <tr class="text-center">
                    <th scope="col">Arquivo</th>
                    <th scope="col">Tipo</th>
                    <th scope="col">Finalidade</th>
                    <th scope="col">Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center" *ngFor="let anexo of arquivosAnexos">
                    <td class="align-middle">{{anexo.nomeArquivo}}</td>
                    <td class="align-middle">{{anexo.tipoAnexo}}</td>
                    <td class="align-middle">
                        <div class="text-center" *ngFor="let fabricante of buscarCategorias(anexo)">{{fabricante}}</div>
                    </td>
                    <td class="align-middle">
                        <a
                            class="btn btn-sm btn-primary "
                            [href]="anexo.link"
                            target="_blank">
                            <i class="fa fa-download fa-fw"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<ng-template #semAnexo>
    <div >
        <h5>A PAC informada não possui arquivos anexados</h5>
    </div>
</ng-template>